import React from "react";
import { FormControl, InputAdornment, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { BLUE_EIGHT } from "../../../theme";
import { Search } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  search: {
    margin: "0"
  },

  searchInput: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
      border: "1px solid #006B7A",

      "& .MuiOutlinedInput-input": {
        fontSize: "10px",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderRadius: "0px",
        border: "none",

      }
    }

  }
}));

export const SearchInput = ({
  error = false,
  label,
  onChange,
  required = false,
  disabled = false,
  value,
  type = "text",
  name,
}) => {
  const classes = useStyles();

  return (
    <FormControl
      className={classes.search}
      variant="outlined"
      fullWidth
      error={error}
    >
      <TextField
        required={required}
        color={BLUE_EIGHT}
        type={type}
        className={classes.searchInput}
        value={value}
        disabled={disabled}
        id="search-input"
        size="small"
        placeholder={label}
        variant="outlined"
        onChange={onChange(name)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              {/* <Search /> */}
              <i className="fa fa-search" style={{ color: "#bbbbbb", marginLeft: 5 }} />
            </InputAdornment>
          ),
        }}
        InputLabelProps={{ shrink: true }}
      />
    </FormControl>
  );
};
